import { PRODUCTS as products } from 'common/constants'
import { productIdFromEdgeProduct } from 'common/api/v1/helpers'
import { EdgeProduct } from 'common/api/v1/types'

export const REACT_APP_EDGE_PRODUCT = productIdFromEdgeProduct(
  (process.env.REACT_APP_EDGE_PRODUCT as EdgeProduct) || EdgeProduct.edge,
)
export const IS_CONNECT_IT = REACT_APP_EDGE_PRODUCT === products.connectIt.id
